import React, { useState, useEffect, useContext, createContext } from 'react';
import { createBrowserRouter, BrowserRouter, Routes, Route, useLocation} from "react-router-dom";
import HomePage from './pages/HomePage';
import './App.css';
import './Mobile.css';
//import './scss/custom.scss';
import Register from './pages/Register';
import Header from './shared/Header';
import Footer from './shared/Footer';
import PersonalInfo from './pages/PersonalInfo';
import Payment from './pages/Payment';
import Address from './pages/Address';
import PersonalLookup from './pages/PersonalLookup';
import PersonalLookupVerify from './pages/PersonalLookupVerify';
import Login from './pages/ManageMembership/Login';
import FooterHome from './shared/FooterHome';
import Child from './components/ContactUSGA';
import Confirmation from './pages/Confirmation';
import Dashboard from './pages/ManageMembership/Dashboard';
import Verify from './pages/ManageMembership/Verify';
import ErrorPage from './ErrorPage';
import ClubMemberships from './pages/ClubMemberships';
import ManageMembership from './pages/ManageMembership/ManageMembership';
import CancelMembership from './pages/ManageMembership/CancelMembership';
import ManagePayments from './pages/ManageMembership/ManagePayments';
import ManageRefund from './pages/ManageMembership/ManageRefund';
import ManageAddress from './pages/ManageMembership/ManageAddress';
import ManageRenewals from './pages/ManageMembership/ManageRenewals';




function App() {

  const [cart, setCart] = useState(0);
  const [counter, setCounter] = useState(JSON.parse(sessionStorage.getItem("basket") || '0'));
  const location = useLocation();
  const [show, setShow] = useState(false);

  const [msg, setMsg] = useState("Initial message");


  useEffect(() => {  
    const basket = JSON.parse(sessionStorage.getItem("basket") || '[]');
  }, [counter])
  
  const handleClick = (item:any) => {
    setCounter(item) ;
  }

  const newMessage = (item:any) => {
    setMsg(item);
  }


  return (
    
    
    <div className="App">

       <div className="app_container">
             {/*<div style={{margin:"100px 0 0 0", position:"fixed", height:"100px", width:"100%"}}>MESSAGE: {msg}</div>*/}

       <Header size={counter} />
      
        <Routes>
         
          <Route path="/" element={<HomePage handleClick={handleClick} />} />
          <Route path="/register" element={<Register handleClick={handleClick}/>} />
          <Route path="/personal-lookup" element={<PersonalLookup />} />
          <Route path="/personal-lookup-verify" element={<PersonalLookupVerify />} />
          <Route path="/personal-info" element={<PersonalInfo />} />
          <Route path="/personal-info/clubs" element={<ClubMemberships />} />
          <Route path="/address" element={<Address />} />
          <Route path="/payment" element={<Payment/>} />
          <Route path="/confirmation" element={<Confirmation />} />
          <Route path="/membership/login" element={<Login/>} />
          <Route path="/membership/verify" element={<Verify/>} />
          <Route path="/membership/dashboard" element={<Dashboard/>} />
          <Route path="/membership/manage/personal" element={<ManageMembership/>} />
          <Route path="/membership/manage/address" element={<ManageAddress/>} />
          <Route path="/membership/manage/cancel" element={<CancelMembership/>} />
          <Route path="/membership/manage/payment" element={<ManagePayments/>} />
          <Route path="/membership/manage/refund" element={<ManageRefund/>} />
          <Route path="/membership/manage/autorenew" element={<ManageRenewals/>} />
          <Route path="/error" element={<ErrorPage />} />
          {/*<FooterHome newMessage={newMessage} handleClick={handleClick}/>*/}
        </Routes>
       
      
       
      </div>
      
      
    <Footer />
    </div>
  );
}

export default App;
